module.exports = __webpack_public_path__ + "static/media/user_empty_icon.b6681619.png";